// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import { BillStatusAndTypeFragmentDoc } from '../../../../../fragments/circularFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanTaskBillModal_ProtoBillsQueryVariables = Types.Exact<{
  planTaskId: Types.Scalars['ID']['input'];
}>;


export type PlanTaskBillModal_ProtoBillsQuery = { __typename?: 'Query', planTask: { __typename?: 'PlanTask', id: string, protoBills: Array<{ __typename?: 'ProtoBill', id: string, existingBills: Array<{ __typename?: 'Bill', id: string, isDeferred: boolean, internalNote?: string | null | undefined, tradePartnerNumber: string, source: { __typename?: 'BillSourceDetail', code: Types.BillSource, name: string }, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, parents: Array<
          | { __typename?: 'Commitment', id: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } }
          | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } }
        >, projectStage: { __typename?: 'ProjectStage', id: string }, lineItems: Array<{ __typename?: 'BillLineItem', id: string, amountInCents: number, commitmentDraw?: { __typename?: 'CommitmentDraw', id: string } | null | undefined, commitmentLineItem?: { __typename?: 'CommitmentLineItem', id: string } | null | undefined, task?: { __typename?: 'Task', id: string } | null | undefined }>, type: { __typename?: 'BillTypeDetail', code: Types.BillType }, status: { __typename?: 'BillStatusDetail', code: Types.BillStatus } }>, lineItems: Array<{ __typename?: 'ProtoBillLineItem', amountInCents: number, commitmentDraw?: { __typename?: 'CommitmentDraw', amountInBasisPoints: number, description?: string | null | undefined, id: string } | null | undefined, commitmentLineItem: { __typename?: 'CommitmentLineItem', id: string, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined } | null | undefined, projectItem: { __typename?: 'ProjectItem', id: string, projectStage: { __typename?: 'ProjectStage', id: string } }, owner:
            | { __typename?: 'Commitment', id: string, accountingNumber: number, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }
            | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }
           } }>, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }> } };

export type PlanTaskBillModal_ProtoBillFragment = { __typename?: 'ProtoBill', id: string, existingBills: Array<{ __typename?: 'Bill', id: string, isDeferred: boolean, internalNote?: string | null | undefined, tradePartnerNumber: string, source: { __typename?: 'BillSourceDetail', code: Types.BillSource, name: string }, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, parents: Array<
      | { __typename?: 'Commitment', id: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } }
    >, projectStage: { __typename?: 'ProjectStage', id: string }, lineItems: Array<{ __typename?: 'BillLineItem', id: string, amountInCents: number, commitmentDraw?: { __typename?: 'CommitmentDraw', id: string } | null | undefined, commitmentLineItem?: { __typename?: 'CommitmentLineItem', id: string } | null | undefined, task?: { __typename?: 'Task', id: string } | null | undefined }>, type: { __typename?: 'BillTypeDetail', code: Types.BillType }, status: { __typename?: 'BillStatusDetail', code: Types.BillStatus } }>, lineItems: Array<{ __typename?: 'ProtoBillLineItem', amountInCents: number, commitmentDraw?: { __typename?: 'CommitmentDraw', amountInBasisPoints: number, description?: string | null | undefined, id: string } | null | undefined, commitmentLineItem: { __typename?: 'CommitmentLineItem', id: string, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined } | null | undefined, projectItem: { __typename?: 'ProjectItem', id: string, projectStage: { __typename?: 'ProjectStage', id: string } }, owner:
        | { __typename?: 'Commitment', id: string, accountingNumber: number, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }
        | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }
       } }>, tradePartner: { __typename?: 'TradePartner', id: string, name: string } };

export type PlanTaskBillModal_BillFragment = { __typename?: 'Bill', id: string, isDeferred: boolean, internalNote?: string | null | undefined, tradePartnerNumber: string, source: { __typename?: 'BillSourceDetail', code: Types.BillSource, name: string }, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, parents: Array<
    | { __typename?: 'Commitment', id: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } }
  >, projectStage: { __typename?: 'ProjectStage', id: string }, lineItems: Array<{ __typename?: 'BillLineItem', id: string, amountInCents: number, commitmentDraw?: { __typename?: 'CommitmentDraw', id: string } | null | undefined, commitmentLineItem?: { __typename?: 'CommitmentLineItem', id: string } | null | undefined, task?: { __typename?: 'Task', id: string } | null | undefined }>, type: { __typename?: 'BillTypeDetail', code: Types.BillType }, status: { __typename?: 'BillStatusDetail', code: Types.BillStatus } };

export const PlanTaskBillModal_BillFragmentDoc = gql`
    fragment PlanTaskBillModal_Bill on Bill {
  id
  ...BillStatusAndType
  source {
    code
    name
  }
  isDeferred
  tradePartner {
    ...Named
  }
  parents {
    id
    accountingNumber
    blueprintUrl {
      path
    }
  }
  internalNote
  projectStage {
    id
  }
  tradePartnerNumber
  lineItems {
    id
    amountInCents
    commitmentDraw {
      id
    }
    commitmentLineItem {
      id
    }
    task {
      id
    }
  }
}
    ${BillStatusAndTypeFragmentDoc}
${NamedFragmentDoc}`;
export const PlanTaskBillModal_ProtoBillFragmentDoc = gql`
    fragment PlanTaskBillModal_ProtoBill on ProtoBill {
  id
  existingBills {
    ...PlanTaskBillModal_Bill
  }
  lineItems {
    amountInCents
    commitmentDraw {
      amountInBasisPoints
      description
      id
    }
    commitmentLineItem {
      id
      primaryBidContractLineItem {
        id
        totalCostInCents
        tradeLineItem {
          id
          options {
            id
            displayName
          }
          totalCostInCents
        }
      }
      projectItem {
        id
        projectStage {
          id
        }
      }
      owner {
        ... on Commitment {
          id
          accountingNumber
          tradePartner {
            ...Named
          }
        }
        ... on CommitmentChangeOrder {
          id
          accountingNumber
          tradePartner {
            ...Named
          }
        }
      }
    }
  }
  tradePartner {
    ...Named
  }
}
    ${PlanTaskBillModal_BillFragmentDoc}
${NamedFragmentDoc}`;
export const PlanTaskBillModal_ProtoBillsDocument = gql`
    query PlanTaskBillModal_ProtoBills($planTaskId: ID!) {
  planTask(id: $planTaskId) {
    id
    protoBills {
      ...PlanTaskBillModal_ProtoBill
    }
  }
}
    ${PlanTaskBillModal_ProtoBillFragmentDoc}`;

/**
 * __usePlanTaskBillModal_ProtoBillsQuery__
 *
 * To run a query within a React component, call `usePlanTaskBillModal_ProtoBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanTaskBillModal_ProtoBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanTaskBillModal_ProtoBillsQuery({
 *   variables: {
 *      planTaskId: // value for 'planTaskId'
 *   },
 * });
 */
export function usePlanTaskBillModal_ProtoBillsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanTaskBillModal_ProtoBillsQuery, PlanTaskBillModal_ProtoBillsQueryVariables> & ({ variables: PlanTaskBillModal_ProtoBillsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanTaskBillModal_ProtoBillsQuery, PlanTaskBillModal_ProtoBillsQueryVariables>(PlanTaskBillModal_ProtoBillsDocument, options);
      }
export function usePlanTaskBillModal_ProtoBillsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanTaskBillModal_ProtoBillsQuery, PlanTaskBillModal_ProtoBillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanTaskBillModal_ProtoBillsQuery, PlanTaskBillModal_ProtoBillsQueryVariables>(PlanTaskBillModal_ProtoBillsDocument, options);
        }
// @ts-ignore
export function usePlanTaskBillModal_ProtoBillsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanTaskBillModal_ProtoBillsQuery, PlanTaskBillModal_ProtoBillsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanTaskBillModal_ProtoBillsQuery, PlanTaskBillModal_ProtoBillsQueryVariables>;
export function usePlanTaskBillModal_ProtoBillsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanTaskBillModal_ProtoBillsQuery, PlanTaskBillModal_ProtoBillsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanTaskBillModal_ProtoBillsQuery | undefined, PlanTaskBillModal_ProtoBillsQueryVariables>;
export function usePlanTaskBillModal_ProtoBillsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanTaskBillModal_ProtoBillsQuery, PlanTaskBillModal_ProtoBillsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanTaskBillModal_ProtoBillsQuery, PlanTaskBillModal_ProtoBillsQueryVariables>(PlanTaskBillModal_ProtoBillsDocument, options);
        }
export type PlanTaskBillModal_ProtoBillsQueryHookResult = ReturnType<typeof usePlanTaskBillModal_ProtoBillsQuery>;
export type PlanTaskBillModal_ProtoBillsLazyQueryHookResult = ReturnType<typeof usePlanTaskBillModal_ProtoBillsLazyQuery>;
export type PlanTaskBillModal_ProtoBillsSuspenseQueryHookResult = ReturnType<typeof usePlanTaskBillModal_ProtoBillsSuspenseQuery>;
export type PlanTaskBillModal_ProtoBillsQueryResult = ApolloReactCommon.QueryResult<PlanTaskBillModal_ProtoBillsQuery, PlanTaskBillModal_ProtoBillsQueryVariables>;